import { isValid } from './basic';

export const handleResponse = (res, okCallback, errCallback) => {
    if (res.status === 200) {
        if (isValid(okCallback)) {
            return okCallback(res.data);
        }
    } else {
        if(res.status < 300) {
            return errCallback(res.data.message, res.status);
        }else{
            return errCallback(res.statusText, res.status);
        }
    }
    return null;
}

export const buildUrl = (baseUrl, params) => {
    const queryString = new URLSearchParams(params).toString();
    return `${baseUrl}?${queryString}`;
}


